module.exports = {
  siteTitle:
    'FeezyHendrix | FullStack Developer, Machine Learning Practitioner and a Hybrid Mobile Developer',
  siteDescription:
    'Full stack software engineer based in Lagos, Nigeria who specializes in developing exceptional, high-quality web applications and we.',
  siteKeywords:
    'Feezy Hendrix, Abdulhafeez Abdulraheem,feezyhendrix, fullstack engineer, software engineer, front-end engineer, web developer, javascript, lagos',
  siteUrl: 'https://feezyhendrix.github.io',
  siteLanguage: 'en_US',
  siteImage: 'https://feezyhendrix.github.io/og.png',
  googleVerification: '7Dz8-Y7JacpDtiUnFiKhehutMHNfKEdp99MjOXC4r8I',

  name: 'AbdulHafeez AbdulRaheem',
  location: 'Lagos, NG',
  email: 'switchdevelop1@gmail.com',
  socialMedia: [
    {
      name: 'Github',
      url: 'https://github.com/FeezyHendrix/',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/feezyhendrix',
    },
    {
      name: 'Medium',
      url: 'https://medium.com/@hafeezraheem',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/feezyhendrix/',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/feezyhendrix',
    },
  ],

  nav: [
    {
      name: 'About',
      url: '#about',
    },
    {
      name: 'Experience',
      url: '#jobs',
    },
    {
      name: 'Work',
      url: '#projects',
    },
    {
      name: 'Contact',
      url: '#contact',
    },
  ],

  twitterHandle: '@feezyhendrix',
  googleAnalyticsID: 'UA-45666519-2',

  headerHeight: 100,

  greenColor: '#64ffda',
  navyColor: '#0a192f',

  srConfig: (delay = 200) => {
    return {
      origin: 'bottom',
      distance: '20px',
      duration: 500,
      delay,
      rotate: { x: 0, y: 0, z: 0 },
      opacity: 0,
      scale: 1,
      easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
      mobile: true,
      reset: false,
      useDelay: 'always',
      viewFactor: 0.25,
      viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
    };
  },
};
